// extracted by mini-css-extract-plugin
export default {"pageContainer":"inicio_pageContainer__n8YnY","titleContainer":"inicio_titleContainer__+UjU8","listNumber":"inicio_listNumber__FTkkk","itemList":"inicio_itemList__xawkF"};